import React from 'react';
import { Link } from 'react-router-dom';

const termsSections = [
  {
    title: 'Service scope',
    body: 'DailyProfit Trader provides trading automation, configuration, and monitoring tools. You remain responsible for broker access, execution decisions, and compliance with your local regulations.',
  },
  {
    title: 'Billing and cancellation',
    body: 'Paid plans are billed on the recurring schedule shown at checkout. Trials, upgrades, and cancellations are managed through your account access and subscription flow.',
  },
  {
    title: 'Risk and responsibility',
    body: 'Markets are volatile. Platform features, alerts, and automation do not guarantee profit or remove trading risk. You should validate settings and monitor connected accounts appropriately.',
  },
  {
    title: 'Account security',
    body: 'You are responsible for keeping login credentials, MT5 credentials, and connected account access secure. Contact support promptly if you suspect unauthorized access.',
  },
];

export default function Terms() {
  return (
    <div className="min-h-screen overflow-hidden bg-[#07111a] text-white">
      <div className="fixed inset-0 -z-20 bg-[radial-gradient(circle_at_top_left,_rgba(27,186,123,0.16),_transparent_28%),radial-gradient(circle_at_80%_20%,_rgba(45,122,255,0.16),_transparent_30%),linear-gradient(180deg,_#09131d_0%,_#05080c_100%)]" />

      <section className="px-4 pb-16 pt-32 sm:px-6 lg:px-8 lg:pt-36">
        <div className="mx-auto max-w-4xl rounded-[2rem] border border-white/10 bg-white/5 p-8 backdrop-blur-xl sm:p-10">
          <div className="flex flex-col gap-4 border-b border-white/10 pb-6 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p className="text-sm uppercase tracking-[0.24em] text-cyan-200/70">Legal</p>
              <h1 className="mt-2 text-4xl font-black text-white sm:text-5xl">Terms of Service</h1>
            </div>
            <Link
              to="/pricing"
              className="inline-flex items-center justify-center rounded-full border border-white/12 bg-white/5 px-5 py-3 text-sm font-bold text-white transition hover:bg-white/10"
            >
              Back to pricing
            </Link>
          </div>

          <p className="mt-6 text-base leading-8 text-slate-300 sm:text-lg">
            These terms summarize how the platform is used, billed, and operated. They are intended to make the checkout and onboarding flow explicit for users evaluating the service.
          </p>

          <div className="mt-10 space-y-5">
            {termsSections.map((section) => (
              <article key={section.title} className="rounded-2xl border border-white/10 bg-slate-950/55 p-5">
                <h2 className="text-xl font-bold text-white">{section.title}</h2>
                <p className="mt-3 text-sm leading-7 text-slate-300 sm:text-base">{section.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}